export const InitialValuesIngPriRefusValidateDoc = {
	file: "",
}